import { useSyncExternalStore } from 'react'

/**
 * Live navigator.onLine. Drives the read-only offline state: edit
 * affordances hide and the shell shows the "viewing your synced copy"
 * notice, so nobody types three paragraphs into a void (Charles,
 * 2026-08-02). onLine can false-positive on captive wifi — harmless here:
 * the save toast still catches the rare liar.
 */
const subscribe = (cb) => {
  window.addEventListener('online', cb)
  window.addEventListener('offline', cb)
  return () => {
    window.removeEventListener('online', cb)
    window.removeEventListener('offline', cb)
  }
}

export function useOnline() {
  return useSyncExternalStore(subscribe, () => navigator.onLine, () => true)
}
